import { useTranslation } from 'react-i18next';
import { enUS, ptBR, pt, es } from 'date-fns/locale';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = { en: enUS, pt, 'pt-BR': ptBR, es };

export const useDateLocale = (): Locale => {
  const { i18n } = useTranslation();
  return localeMap[i18n.language] ?? enUS;
};
